import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

export interface BankDetailsForm {
  bankName: string;
  accountHolderName: string;
  accountNo: string;
  iban: string;
}

interface BankDetails {
  bankName?: {
    value: string;
    label: string;
  };
  accountHolderName?: string;
  accountNo?: string;
  iban?: string;
}

export const useInitializeBankDetail = (
  setValue: UseFormReturn<BankDetailsForm>["setValue"],
  bankDetails?: BankDetails,
  bankList?: any,
) => {
  useEffect(() => {
    if (!bankDetails) return;
    const bank = bankList?.filter(
      (item) => item?.value === bankDetails.bankName || item?.label === bankDetails.bankName,
    );
    setValue("bankName", bank);
    setValue("accountHolderName", bankDetails.accountHolderName || "");
    setValue("accountNo", bankDetails.accountNo || "");
    setValue("iban", bankDetails.iban || "");
  }, [bankDetails]);
};
